import { useEffect, useState } from "react";

import { DEFAULT_TIMEZONE } from "@consts";
import { DIALOG_TYPES } from "./AccountEditorConsts";
import useAccountEditorDialog from "./useAccountEditorDialog";

const useAccountEditorController = ({
  accountData,
  type,
  error,
  errorText,
  onConfirm,
  onResetError
}) => {
  const [newAccountData, setNewAccountData] = useState(
    accountData || {
      accountId: { value: "", errorText: "" },
      name: { value: "", errorText: "" },
      timezone: { value: DEFAULT_TIMEZONE, errorText: "" }
    }
  );

  const { dialogContent } = useAccountEditorDialog({
    error,
    errorText,
    type,
    accountData: newAccountData
  });

  const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (error) {
      setIsLoading(false);
      setIsConfirmationDialogOpen(false);
    }
  }, [error]);

  const hasNameError = !!newAccountData?.name.errorText;
  const hasAccountIdError = !!newAccountData?.accountId.errorText;
  const noChanges = newAccountData?.name.value === accountData?.name.value
    && newAccountData?.accountId.value === accountData?.accountId.value
    && newAccountData?.timezone?.value === accountData?.timezone?.value;

  const isSaveDisabled = type !== "delete" && (hasNameError || hasAccountIdError || noChanges);

  const handleTextFieldChange = ({ target }, validationFn) => {
    const errorText = validationFn ? validationFn(target.value) : "";

    setNewAccountData({
      ...newAccountData,
      [target.name]: { value: target.value, errorText }
    });
  };

  const handleSaveButtonClicked = () => {
    if (error) return onResetError();

    if (type === DIALOG_TYPES.create || type === DIALOG_TYPES.delete) {
      typeof onConfirm === "function" && onConfirm(newAccountData);
      setIsLoading(true);
    }
    else {
      setIsConfirmationDialogOpen(true);
    }
  };

  const handleConfirmationSubmit = () => {
    typeof onConfirm === "function" && onConfirm(newAccountData);
    setIsLoading(true);
  };

  const handleConfirmationClose = () => {
    setIsConfirmationDialogOpen(false);
  };

  const handleDirectSubmit = () => {
    typeof onConfirm === "function" && onConfirm(newAccountData);
    setIsLoading(true);
  };

  return {
    newAccountData,
    dialogContent,
    isConfirmationDialogOpen,
    isLoading,
    isSaveDisabled,
    handleTextFieldChange,
    handleSaveButtonClicked,
    handleConfirmationSubmit,
    handleConfirmationClose,
    handleDirectSubmit
  };
};

export default useAccountEditorController;

